import { render, staticRenderFns } from "./CrewChangePeopleList.vue?vue&type=template&id=4a6f7b3a&scoped=true&"
import script from "./CrewChangePeopleList.vue?vue&type=script&lang=js&"
export * from "./CrewChangePeopleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6f7b3a",
  null
  
)

export default component.exports